// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"706":"eea0badd","787":"af891aa7","909":"fbdd110c"}[chunkId] + ".chunk.js";
};